import React from 'react';
import ReactEcharts from 'echarts-for-react';

export const LineChart = ({ title, xAxisName, yAxisName, seriesCollection }) => {
    var xValues = [];
    seriesCollection.forEach((series) => {
        series.points.forEach((point) => {
            xValues.push(point[0]);
        });
    });
    var yValues = [];
    seriesCollection.forEach((series) => {
        series.points.forEach((point) => {
            yValues.push(point[1]);
        });
    });

    var min = Math.min(...xValues, ...yValues);
    var max = Math.max(...xValues, ...yValues);
    var range = max - min;
    const option = {
        title: {
            text: title,
            left: 'center'
        },
        tooltip: {
            trigger: 'item',
            formatter: (p) => {
                const [x, y] = p.value;
                return `${p.marker} ${p.seriesName}<br/>`
                    + `${xAxisName}: ${Number(x).toFixed(2)} m<br/>`
                    + `${yAxisName}: ${Number(y).toFixed(2)} m`;
            }
        },
        axisPointer: {
            link: [{ xAxisIndex: 'all', yAxisIndex: 'all' }],
            label: { backgroundColor: '#6a7985' }
        },
        toolbox: {
            feature: {
                saveAsImage: {},
                dataZoom: {},
                dataView: {}
            }
        },
        xAxis: {
            min: Math.floor(Math.min(...xValues)),
            max: Math.ceil(Math.min(...xValues) + range),
            name: xAxisName,
            type: 'value',
            scale: true,
            axisLabel: {
                formatter: '{value} m'
            },
            splitLine: {
                show: true
            }
        },
        yAxis: {
            min: Math.floor(Math.min(...yValues)),
            max: Math.ceil(Math.min(...yValues) + range),
            name: yAxisName,
            type: 'value',
            scale: true,
            axisLabel: {
                formatter: '{value} m'
            },
            splitLine: {
                show: true
            }
        },
        // An explicit series.color pins the colour to the entity rather than to
        // its position in the array, so filtering the collection cannot repaint
        // the series that remain. Without it ECharts colours by series index.
        series: seriesCollection.map((series) => ({
            name: series.name,
            type: 'line',
            data: series.points,
            smooth: true,
            ...(series.color ? { itemStyle: { color: series.color } } : {}),
            lineStyle: {
                width: 2,
                ...(series.color ? { color: series.color } : {}),
                ...series.lineStyle
            }
        }))
    };

    return (
        // notMerge, as every other chart in the app does: echarts merges a new
        // option into the old one by series index, so without this a series
        // dropped from seriesCollection stays drawn on the chart.
        <ReactEcharts
            option={option}
            notMerge={true}
            style={{ height: 600, width: 600 }} />
    );
}